import {
  SET_BILLER,
  SET_BILLER_LIST,
  SET_BILLER_PREFIX,
  SET_CHECKOUT,
  UPDATE_CHECKOUT_PARAM,
  RESET_FORM_PAGE,
  SET_USER_AGREEMENTS,
} from 'redux/actions/types';

import {
  checkoutSample,
  checkoutParamSample,
} from 'constant/fictures/BillerPage.fictures';

const initialState = {
  biller: {},
  billerList: [],
  prefixList: [],
  // checkout: {},
  // checkoutParam: {},
  checkout: checkoutSample,
  checkoutParam: checkoutParamSample,
  userAgreements: [],
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BILLER:
      return {
        ...state,
        biller: action.payload,
      };
    case SET_BILLER_LIST:
      return {
        ...state,
        billerList: action.payload,
      };
    case SET_BILLER_PREFIX:
      return {
        ...state,
        prefixList: action.payload,
      };
    case SET_CHECKOUT:
      return {
        ...state,
        checkout: action.payload,
      };
    case UPDATE_CHECKOUT_PARAM:
      return {
        ...state,
        checkoutParam: action.param,
      };
    case RESET_FORM_PAGE:
      return {
        ...state,
        biller: initialState.biller,
        checkout: initialState.checkout,
        checkoutParam: initialState.checkoutParam,
        checkoutErrorMessage: initialState.checkoutErrorMessage,
      };
    case SET_USER_AGREEMENTS:
      return {
        ...state,
        userAgreements: action.payload,
      };
    default:
      return state;
  }
};
